import { Button } from "theme-ui";

export default Button;
